var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.6H2.77778M2.77778 4.6H17M2.77778 4.6V17.2C2.77778 17.6774 2.96508 18.1352 3.29848 18.4728C3.63187 18.8104 4.08406 19 4.55556 19H13.4444C13.9159 19 14.3681 18.8104 14.7015 18.4728C15.0349 18.1352 15.2222 17.6774 15.2222 17.2V4.6H2.77778ZM5.44444 4.6V2.8C5.44444 2.32261 5.63175 1.86477 5.96514 1.52721C6.29854 1.18964 6.75073 1 7.22222 1H10.7778C11.2493 1 11.7015 1.18964 12.0349 1.52721C12.3683 1.86477 12.5556 2.32261 12.5556 2.8V4.6M7.22222 9.1V14.5M10.7778 9.1V14.5",
    stroke: "#E05656",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.6a137737872a0247f42b63a24626da18.svg";
export { ForwardRef as ReactComponent };